const ApplicationLogo = (props) => {

  if (props.is_auth) {
    return (
      <div className="d-flex align-items-center conatiner-logo-auth">
        <img src="/pefindo-biru.png" alt="Logo" />

        <div className="title-logo">MANRISK</div>

      </div>
    );
  }
  return (
    <img
      src={props?.src || "/pefindo-biru.png"}
      alt="Logo"
      width={props.width ? props.width : "88"}
      height={props.height ? props.height : "63"}
    />
  );
};

export default ApplicationLogo;
